import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconPerson.tsx
const OutlinedFilledPerson = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M479.8-494q-77.21 0-126-48.8-48.8-48.79-48.8-126 0-77.2 48.8-126.2 48.79-49 126-49 77.2 0 126.7 49T656-668.8q0 77.21-49.5 126Q557-494 479.8-494ZM135-122v-120.79q0-44.51 22.83-77.73Q180.66-353.73 217-371q69-31 133.46-46.5Q414.92-433 479.73-433q66.73 0 130.5 16Q674-401 742-371q37.61 15.96 60.8 49.48Q826-288 826-243.05V-122H135Z" })
});
const OutlinedPerson = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M479.8-494q-77.21 0-126-48.8-48.8-48.79-48.8-126 0-77.2 48.8-126.2 48.79-49 126-49 77.2 0 126.7 49T656-668.8q0 77.21-49.5 126Q557-494 479.8-494ZM135-122v-120.79q0-44.51 22.83-77.73Q180.66-353.73 217-371q69-31 133.46-46.5Q414.92-433 479.73-433q66.73 0 130.5 16 63.77 16 131.69 46.19 37.91 16.09 61 49.45Q826-288 826-243.05V-122H135Zm94-94h502v-23q0-15.35-9.5-29.32T698-289q-60-28-110.5-38.5-50.49-10.5-108-10.5-55.5 0-108 10.5t-110.07 38.34Q247-282.44 238-268.42q-9 14.01-9 29.42v23Zm250.8-372q35.2 0 58.2-22.85 23-22.84 23-58.11 0-35.69-22.8-58.37-22.79-22.67-58-22.67-35.2 0-58.2 22.72t-23 57.82q0 35.51 22.8 58.49 22.79 22.97 58 22.97Zm.2-81Zm0 453Z" })
});
const RoundedFilledPerson = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M479.8-494q-77.21 0-126-48.8-48.8-48.79-48.8-126 0-77.2 48.8-126.2 48.79-49 126-49 77.2 0 126.7 49T656-668.8q0 77.21-49.5 126Q557-494 479.8-494ZM135-216v-27q0-44 22.63-77.42Q180.27-353.83 217-371q69-31 133.5-46.5T479.73-433q66.73 0 130.5 16Q674-401 742-371q38 16 61 49.5t23 78.5v27q0 39-27.27 66.5T731-122H229q-40.05 0-67.02-27.5Q135-177 135-216Z" })
});
const RoundedPerson = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M479.8-494q-77.21 0-126-48.8-48.8-48.79-48.8-126 0-77.2 48.8-126.2 48.79-49 126-49 77.2 0 126.7 49T656-668.8q0 77.21-49.5 126Q557-494 479.8-494ZM135-216v-27q0-44.3 22.83-77.52Q180.66-353.73 217-371q69-31 133.46-46.5Q414.92-433 479.73-433q66.73 0 130.5 16 63.77 16 131.69 46.19 37.91 16.09 61 49.45Q826-288 826-243v27q0 38.75-27.39 66.37Q771.21-122 731-122H229q-39.8 0-66.9-27.63Q135-177.25 135-216Zm94 0h502v-23q0-15.35-9.5-29.32T698-289q-60-28-110.5-38.5-50.49-10.5-108-10.5-55.5 0-108 10.5t-110.07 38.34Q247-282.44 238-268.42q-9 14.01-9 29.42v23Zm250.8-372q35.2 0 58.2-22.85 23-22.84 23-58.11 0-35.69-22.8-58.37-22.79-22.67-58-22.67-35.2 0-58.2 22.72t-23 57.82q0 35.51 22.8 58.49 22.79 22.97 58 22.97Zm.2-81Zm0 453Z" })
});
const SharpFilledPerson = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M479.8-494q-77.21 0-126-48.8-48.8-48.79-48.8-126 0-77.2 48.8-126.2 48.79-49 126-49 77.2 0 126.7 49T656-668.8q0 77.21-49.5 126Q557-494 479.8-494ZM135-122v-120.79q0-44.51 22.83-77.73Q180.66-353.73 217-371q69-31 133.46-46.5Q414.92-433 479.73-433q66.73 0 130.5 16Q674-401 742-371q37.61 15.96 60.8 49.48Q826-288 826-243.05V-122H135Z" })
});
const SharpPerson = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M479.8-494q-77.21 0-126-48.8-48.8-48.79-48.8-126 0-77.2 48.8-126.2 48.79-49 126-49 77.2 0 126.7 49T656-668.8q0 77.21-49.5 126Q557-494 479.8-494ZM135-122v-120.79q0-44.51 22.83-77.73Q180.66-353.73 217-371q69-31 133.46-46.5Q414.92-433 479.73-433q66.73 0 130.5 16 63.77 16 131.69 46.19 37.91 16.09 61 49.45Q826-288 826-243.05V-122H135Zm94-94h502v-23q0-15.35-9.5-29.32T698-289q-60-28-110.5-38.5-50.49-10.5-108-10.5-55.5 0-108 10.5t-110.07 38.34Q247-282.44 238-268.42q-9 14.01-9 29.42v23Zm250.8-372q35.2 0 58.2-22.85 23-22.84 23-58.11 0-35.69-22.8-58.37-22.79-22.67-58-22.67-35.2 0-58.2 22.72t-23 57.82q0 35.51 22.8 58.49 22.79 22.97 58 22.97Zm.2-81Zm0 453Z" })
});
const componentMap = {
	outlined: OutlinedPerson,
	"outlined-fill": OutlinedFilledPerson,
	rounded: RoundedPerson,
	"rounded-fill": RoundedFilledPerson,
	sharp: SharpPerson,
	"sharp-fill": SharpFilledPerson
};
const IconPerson = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconPerson };